module.exports = __webpack_public_path__ + "static/img/check.0221a113.svg";